import qs from 'querystringify';
import { trackEvent } from 'fathom-client';

import { DISCORD_FINISHED_PROJECTS_URL } from 'features/pages/slice';

import {
  Button,
  Card,
  flash,
  Icon,
  LinkWithButtonStyles,
  Markdown,
} from '@frontendmentorio/design-system-v2';

export default function Content({ solution, subtitle }) {
  const TEMPLATE = `I've just completed a front-end coding challenge from @frontendmentor! 🎉

You can see my solution here: https://www.frontendmentor.io/solutions/${solution.slug}

Any suggestions on how I can improve are welcome!`;

  const handleCopy = () => {
    navigator.clipboard.writeText(TEMPLATE);
    flash.success('Template copied!');
  };

  return (
    <div className="flex flex-col gap-5 items-center text-center w-full">
      <div className="flex flex-col gap-4">
        <span className="font-secondary font-semibold text-lg text-blue-500">
          {subtitle}
        </span>

        <span className="text-neutral-500">
          Sharing your project with others can increase the chances of receiving
          feedback. Plus, we’re sure people will want to see what you’ve built!
          We’ve added some simple sharing options below.
        </span>
      </div>

      <div className="flex flex-wrap gap-3 items-center justify-center">
        <LinkWithButtonStyles
          ariaLabel="X (opens in a new tab)"
          href={`https://x.com/intent/tweet?${qs.stringify({
            text: TEMPLATE,
          })}`}
          level="secondary"
          onClick={() => trackEvent('Sharing: Twitter')}
          target="_blank"
        >
          <Icon className="text-lg" name="x-twitter" style="brands" />
        </LinkWithButtonStyles>

        <LinkWithButtonStyles
          ariaLabel="LinkedIn (opens in a new tab)"
          href={`https://www.linkedin.com/sharing/share-offsite/?${qs.stringify(
            {
              url: `https://www.frontendmentor.io/solutions/${solution.slug}`,
            }
          )}`}
          level="secondary"
          onClick={() => trackEvent('Sharing: LinkedIn')}
          target="_blank"
        >
          <Icon className="text-lg" name="linkedin" style="brands" />
        </LinkWithButtonStyles>

        <LinkWithButtonStyles
          ariaLabel="Facebook (opens in a new tab)"
          href={`https://www.facebook.com/sharer.php?${qs.stringify({
            u: `https://www.frontendmentor.io/solutions/${solution.slug}`,
          })}`}
          level="secondary"
          onClick={() => trackEvent('Sharing: Facebook')}
          target="_blank"
        >
          <Icon className="text-lg" name="facebook" style="brands" />
        </LinkWithButtonStyles>

        <LinkWithButtonStyles
          ariaLabel="Discord (opens in a new tab)"
          href={DISCORD_FINISHED_PROJECTS_URL}
          level="secondary"
          onClick={() => trackEvent('Sharing: Discord')}
          target="_blank"
        >
          <Icon className="text-lg" name="discord" style="brands" />
        </LinkWithButtonStyles>
      </div>

      <div className="bg-gray-100 flex flex-col gap-4 p-5 rounded-xl text-start w-full">
        <span className="font-bold">Here’s an example message template</span>

        <Card className="bg-neutral-50 p-5">
          <Markdown className="overflow-x-auto">{TEMPLATE}</Markdown>
        </Card>

        <Button
          className="w-full"
          isGhost
          level="secondary"
          onClick={handleCopy}
        >
          Copy template
        </Button>
      </div>
    </div>
  );
}
